import { render, staticRenderFns } from "./staff-penalties.vue?vue&type=template&id=15e22a30&"
import script from "./staff-penalties.vue?vue&type=script&lang=js&"
export * from "./staff-penalties.vue?vue&type=script&lang=js&"
import style0 from "./staff-penalties.vue?vue&type=style&index=0&id=15e22a30&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports